import { ServiceDeskConfig } from "../Startup/serviceDeskConfig";
import { HttpTrackingConfig } from "../../ShellCommon/logger/http-interceptor";
import { MsalAuthenticationServiceImplementation } from "./msal/msal-authentication-service";

export interface VisitAttribute {
  Name: string;
  Value: string;
}
export interface VisitDetails {
  UniqueIdentifier: string;
  Language: string;
  Country: string;
  Attributes: VisitAttribute[];
}
export interface VisitService {
  updateVisit(visitDetails: VisitDetails): ng.IPromise<any>;
}
export class VisitServiceImplementation implements VisitService {
  // todo: static $inject: Array<string> = ["$http", "msalAuthenticationService", "$q"];

  // @ngInject
  constructor(
    private $http: ng.IHttpService,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private $q: ng.IQService,
    private sdConfig: ServiceDeskConfig
  ) {}
  updateVisit(visitDetails: VisitDetails): ng.IPromise<any> {
    let deferred = this.$q.defer();

    this.msalAuthenticationService._getCachedToken(this.sdConfig.msalScopes).then(function (token) {
      var cachedToken: string = "null";
      if (token) {
        cachedToken = token;
      }

      this.$http
        .post(this.sdConfig.sdBaseUrl + "SDController/api/Visit", visitDetails, <HttpTrackingConfig>{
          headers: {
            Authorization: "bearer " + cachedToken
          },
          dependencyOperationName: "Visit.Post"
        })
        .then(
          (callback: any) => {
            deferred.resolve(callback.data);
          },
          (error: any) => {
            deferred.reject(error);
          }
        );
    });

    return deferred.promise;
  }
}
